export const messages = {
  en: {
    classesManage: {
      search: {
        title: 'Search Conditions',
        namePlaceholder: 'Please enter class name'
      },
      list: {
        title: 'Class Information'
      },
      table: {
        classesId: 'ID',
        name: 'Class Name',
        times: 'Time Period',
        state: 'Status',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      add: {
        title: 'Add Class',
        name: 'Class Name',
        namePlaceholder: 'Please enter class name',
        workTime: 'Work Time',
        startTimePlaceholder: 'Start Time',
        endTimePlaceholder: 'End Time',
        addTime: 'Add Time',
        remark: 'Remark',
        remarkPlaceholder: 'Please enter remark'
      },
      edit: {
        title: 'Edit Class',
        name: 'Class Name',
        namePlaceholder: 'Please enter class name',
        workTime: 'Work Time',
        startTimePlaceholder: 'Start Time',
        endTimePlaceholder: 'End Time',
        addTime: 'Add Time',
        remark: 'Remark',
        remarkPlaceholder: 'Please enter remark'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmMessage: 'Are you sure to delete this class?'
      },
      state: {
        title: 'Status Confirmation',
        confirmMessage: 'Are you sure to {action} this {name}?',
        successMessage: '{action} successfully',
        classes: 'class'
      },
      validate: {
        nameRequired: 'Class name is required',
        nameMaxLength: 'Class name cannot exceed 100 characters',
        remarkRequired: 'Remark is required',
        remarkMaxLength: 'Remark cannot exceed 200 characters'
      },
      fetchError: 'Failed to fetch class data'
    }
  },
  zh: {
    classesManage: {
      search: {
        title: '查询条件',
        namePlaceholder: '请输入班次名称'
      },
      list: {
        title: '班次信息'
      },
      table: {
        classesId: '编号',
        name: '班次名称',
        times: '时段',
        state: '状态',
        createTime: '创建时间',
        remark: '备注说明'
      },
      add: {
        title: '添加班次',
        name: '班次名称',
        namePlaceholder: '请输入班次名称',
        workTime: '工作时间',
        startTimePlaceholder: '上班时间',
        endTimePlaceholder: '下班时间',
        addTime: '增加时段',
        remark: '备注说明',
        remarkPlaceholder: '请输入备注说明'
      },
      edit: {
        title: '修改班次',
        name: '班次名称',
        namePlaceholder: '请输入班次名称',
        workTime: '工作时间',
        startTimePlaceholder: '上班时间',
        endTimePlaceholder: '下班时间',
        addTime: '增加时段',
        remark: '备注说明',
        remarkPlaceholder: '请输入备注说明'
      },
      delete: {
        title: '删除确认',
        confirmMessage: '确定删除该班次吗?'
      },
      state: {
        title: '状态确认',
        confirmMessage: '确定{action}该{name}吗?',
        successMessage: '{action}成功',
        classes: '班次'
      },
validate: {
        nameRequired: '班次名称不能为空',
        nameMaxLength: '班次名称不能超过100个字符',
        remarkRequired: '备注说明不能为空',
        remarkMaxLength: '备注说明不能超过200个字符'
      },
      fetchError: '获取班次数据失败'
    }
  },
  'zh-TW': {
    classesManage: {
      search: {
        title: '查詢條件',
        namePlaceholder: '請輸入班次名稱'
      },
      list: {
        title: '班次信息'
      },
      table: {
        classesId: '編號',
        name: '班次名稱',
        times: '時段',
        state: '狀態',
        createTime: '創建時間',
        remark: '備註說明'
      },
      add: {
        title: '添加班次',
        name: '班次名稱',
        namePlaceholder: '請輸入班次名稱',
        workTime: '工作時間',
        startTimePlaceholder: '上班時間',
        endTimePlaceholder: '下班時間',
        addTime: '增加時段',
        remark: '備註說明',
        remarkPlaceholder: '請輸入備註說明'
      },
      edit: {
        title: '修改班次',
        name: '班次名稱',
        namePlaceholder: '請輸入班次名稱',
        workTime: '工作時間',
        startTimePlaceholder: '上班時間',
        endTimePlaceholder: '下班時間',
        addTime: '增加時段',
        remark: '備註說明',
        remarkPlaceholder: '請輸入備註說明'
      },
      delete: {
        title: '刪除確認',
        confirmMessage: '確定刪除該班次嗎?'
      },
      state: {
        title: '狀態確認',
        confirmMessage: '確定{action}該{name}嗎?',
        successMessage: '{action}成功',
        classes: '班次'
      },
      validate: {
        nameRequired: '班次名稱不能為空',
        nameMaxLength: '班次名稱不能超過100個字符',
        remarkRequired: '備註說明不能為空',
        remarkMaxLength: '備註說明不能超過200個字符'
      },
      fetchError: '獲取班次數據失敗'
    }
  }
}